import React from 'react';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import { IncomeModel } from '../../api/useIncomeQuery';
import { UPSERT_INCOME_FORM_ID } from '../../components/UpsertIncomeModal/UpsertIncomeModal.meta';
import { IncomeData } from '../../useIncome';
import { EmploymentFormFields } from './EmploymentFormFields';
import { useEmploymentForm } from './useEmploymentForm';

export interface Props {
  clientId: string;
  income: IncomeModel | null;
  data: IncomeData;
  onSuccess: () => void;
}

export const EmploymentForm = ({ clientId, income, data, onSuccess }: Props) => {
  const {
    data: { formBag, mutationBag, defaultShowAdvanced },
    actions: { onSubmit },
  } = useEmploymentForm({ clientId, income, data, onSuccess });

  return (
    <form
      onSubmit={onSubmit}
      id={UPSERT_INCOME_FORM_ID}
      css={`
        display: flex;
        flex-direction: column;
        gap: 16px;
      `}
      aria-label="Employment income form"
    >
      {mutationBag.error && (
        <Alert
          variant="error"
          message={mutationBag.error.message}
          onRequestClose={mutationBag.reset}
        />
      )}

      <EmploymentFormFields
        formBag={formBag}
        options={data.Options}
        defaultShowAdvanced={defaultShowAdvanced}
      />
    </form>
  );
};
